// extracted by css-extract-rspack-plugin
export default {"BlankslateContainer":"Blankslate-module__BlankslateContainer__Qfa7w"};